import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { handletoken } from "redux/festures/alertSlice";

export const firebaseConfig = {
  apiKey: "AIzaSyDNYaslVktVd07sbOdhez0f7HKr9wCx0a0",
  authDomain: "easysolution-services.firebaseapp.com",
  projectId: "easysolution-services",
  storageBucket: "easysolution-services.firebasestorage.app",
  messagingSenderId: "716633848130",
  appId: "1:716633848130:web:777b04db2de4cd23c4f0db",
  measurementId: "G-3YLB3ERC1G"
};

export const app = initializeApp(firebaseConfig);

let messagingInstance = null;

const getMessagingInstance = async () => {
  if (messagingInstance) return messagingInstance;
  try {
    const supported = typeof window !== "undefined" && (await isSupported());
    if (supported) {
      messagingInstance = getMessaging(app);
      return messagingInstance;
    }
  } catch (err) {
    console.warn("Firebase Messaging is not supported:", err);
  }
  return null;
};

export const requestPermission = async (setValue) => {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) {
      return;
    }

    const messaging = await getMessagingInstance();
    if (!messaging) {
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey: `BKdct2CIi4l_gklMq3kukqrxgyQURwNjuX8IOlCV9tUIWCNA1CYOyeUR8_EGnEJFXHYVze_6YrLdGVQCgNAFN9A`,
      });
      if (currentToken && typeof setValue === "function") {
        setValue(handletoken(currentToken));
      }
    } else {
      // console.log("User Permission Denied.");
    }
  } catch (err) {
    console.warn("Firebase notification permission error:", err);
  }
};

export const onMessageListener = () =>
  new Promise(async (resolve, reject) => {
    try {
      const messaging = await getMessagingInstance();
      if (!messaging) {
        return;
      }
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    } catch (err) {
      console.warn("Firebase onMessage error:", err);
    }
  });

